/*
 * @Author: Dong
 * @Date: 2022-04-07 18:34:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-04-25 16:58:45
 */
import React, { useEffect } from 'react';
import styles from './index.less';
import { useIntl } from 'react-intl';
import messages from './messages';

interface PropsType {
  percentage: number; // 进度
  id: string; // canvas id
  warning: boolean; // 是否超过阈值
}

const Progress = (props: PropsType) => {
  const intl = useIntl();
  const { percentage, id, warning } = props;

  useEffect(() => {
    const c: HTMLCanvasElement = document.getElementById(id) as HTMLCanvasElement;
    if (!c.getContext) return;

    const ctx: any = c.getContext('2d') as CanvasRenderingContext2D;

    const precent = 100;
    let num = 0;
    const startColor = warning ? '#f2f5f9' : '#f0f5f8';
    const endColor = warning ? '#d20c0c' : '#2280fa';
    const colorArr: any[] = [];

    ctx.fillStyle = '#FF0000';

    // 计算渐变色数组
    (function getColorArr() {
      const startRgb = hexToRgb(startColor) || [];
      const endRgb = hexToRgb(endColor) || [];

      const stepR = (endRgb[0] - startRgb[0]) / precent;
      const stepG = (endRgb[1] - startRgb[1]) / precent;
      const stepB = (endRgb[2] - startRgb[2]) / precent;

      for (let i = 0; i <= precent; i++) {
        let hex = rgbToHex(startRgb[0] + stepR * i, startRgb[1] + stepG * i, startRgb[2] + stepB * i);
        hex = hex.length === 4 ? '00' + hex : hex.length === 5 ? '0' + hex : hex;
        colorArr.push('#' + hex);
      }
    })();

    function hexToRgb(hex: any) {
      if (hex.length === 4)
        return [
          parseInt('0x' + hex.slice(1, 2).repeat(2), 16),
          parseInt('0x' + hex.slice(2, 3).repeat(2), 16),
          parseInt('0x' + hex.slice(3, 4).repeat(2), 16),
        ];
      else if (hex.length === 7)
        return [
          parseInt('0x' + hex.slice(1, 3), 16),
          parseInt('0x' + hex.slice(3, 5), 16),
          parseInt('0x' + hex.slice(5, 7), 16),
        ];
      else alert('颜色错误');
    }

    function rgbToHex(r: any, g: any, b: any) {
      return ((r << 16) | (g << 8) | b).toString(16);
    }

    // 绘制轨道
    drawTrack();
    function drawTrack() {
      ctx.save();
      ctx.beginPath();
      ctx.lineCap = 'round';
      ctx.lineWidth = 8;
      ctx.strokeStyle = '#e5f1fa';
      ctx.arc(45, 45, 38, 0, 2 * Math.PI);
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    }

    // 绘制进度环
    function drawProgress(num: number) {
      ctx.save();
      ctx.beginPath();
      ctx.lineCap = num === precent ? '' : 'round';
      ctx.lineWidth = 8;
      // ctx.strokeStyle = '#2ba0fb'
      ctx.strokeStyle = colorArr[num];
      // context.arc(x,y,r,sAngle,eAngle,counterclockwise);   //x坐标,y坐标,半径,起始角,结束角,顺时针/逆时针
      ctx.arc(
        45,
        45,
        38,
        -Math.PI / 2 + ((2 * (num - 1)) / (100 / percentage)) * Math.PI,
        -Math.PI / 2 + ((2 * num) / (100 / percentage)) * Math.PI,
      );
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    }

    // 绘制文字
    function drawText(num: any) {
      ctx.save();
      ctx.fillStyle = '#3396c7';

      ctx.font = '40px Helvetica';
      ctx.textAlign = 'center';
      ctx.fillText(num + '%', 150, 160);
      ctx.restore();
    }

    // 动画
    (function draw() {
      // 如果进度为0，不绘制进度
      if (!percentage) return;

      ctx.clearRect(85, 85, 130, 130);
      drawProgress(num);
      drawText(num);
      num += 2;
      if (num <= precent) window.requestAnimationFrame(draw);
      else num = precent;
    })();
  }, [percentage, warning]);

  return (
    <div className={styles.Progress}>
      <canvas id={id} width="89" height="89">
        {intl.formatMessage(messages.tip)}
      </canvas>
    </div>
  );
};

export default Progress;
